import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  COMPANY_QUALITIES_NAMES,
  COMPETITIVE_ANALYSIS_NAMES,
  COMPETITORS_COMPARISON_NAMES,
  FEATURES_FOR_COMPARISON_NAMES,
  FEATURES_LIST_NAMES,
  KEY_COMPETITORS_NAMES,
} from 'components/BusinessToolForm/Sections/MarketAnalysis/CompetitiveAnalysis/utils/form';
import {
  B2B_NAMES,
  B2C_NAMES,
  CONSUMER_NEEDS_NAMES,
} from 'components/BusinessToolForm/Sections/MarketAnalysis/ConsumerNeeds/utils/form';
import {
  AVERAGE_PRICES_CHART_NAMES,
  CONSUMER_DETAILS_NAMES,
  CURRENT_MARKET_STRUCTURE_NAMES,
  FORECASTED_CONSUMPTION_CHART_NAMES,
  MARKET_ANALYSIS_OVERVIEW_NAMES,
  MARKET_TRENDS_FIELD_NAMES,
  REGION_PERIODS_NAMES,
  REGIONS_PRODUCT_NAMES,
} from 'components/BusinessToolForm/Sections/MarketAnalysis/MarketAnalysisOverview/utils/form';

import { ul } from '../helpers';

const YEARS_ROW_INSTRUCTIONS = {
  name: 'Valor',
  instruction: 'Indique el valor del mercado de forma precisa, clara y verificable.',
};

const CONSUMPTION_TABLE_DATA_INSTRUCTIONS = {
  [REGION_PERIODS_NAMES.Y1]: YEARS_ROW_INSTRUCTIONS,
  [REGION_PERIODS_NAMES.Y2]: YEARS_ROW_INSTRUCTIONS,
  [REGION_PERIODS_NAMES.Y3]: YEARS_ROW_INSTRUCTIONS,
  [REGION_PERIODS_NAMES.Y4]: YEARS_ROW_INSTRUCTIONS,
  [REGION_PERIODS_NAMES.Y5]: YEARS_ROW_INSTRUCTIONS,
  [REGION_PERIODS_NAMES.Y6]: YEARS_ROW_INSTRUCTIONS,

  [REGION_PERIODS_NAMES.REGION]: {
    name: 'Nombre',
    instruction: 'Indique el nombre exacto del mercado o de la región analizada.',
    exampleOne: 'Estados Unidos',
    exampleTwo: 'Europa',
  },
};

const FORECASTED_CONSUMPTION_CHART_INSTRUCTIONS = {
  [FORECASTED_CONSUMPTION_CHART_NAMES.TITLE]: {
    name: 'Proyección del consumo',

    instruction: 'Introduzca un título claro y conciso que describa con precisión el contenido del gráfico.',

    exampleOne: 'Mercado europeo de servicios financieros',
    exampleTwo: 'Mercado estadounidense de maquinaria agrícola',
  },

  [FORECASTED_CONSUMPTION_CHART_NAMES.REGION]: {
    name: '',
    instruction: '',
    exampleOne: '',
    exampleTwo: '',
  },

  [FORECASTED_CONSUMPTION_CHART_NAMES.UNITS]: {
    name: '',
    instruction: '',
    exampleOne: '',
    exampleTwo: '',
  },

  [FORECASTED_CONSUMPTION_CHART_NAMES.TABLE_ROWS]: CONSUMPTION_TABLE_DATA_INSTRUCTIONS,

  [FORECASTED_CONSUMPTION_CHART_NAMES.SOURCE]: {
    name: 'Fuente de los datos',

    instruction: 'Indique la fuente fiable o la metodología utilizada para obtener la información.',

    exampleOne: 'Eurostat',
    exampleTwo: 'Statista',
  },
};

const CONSUMER_DETAILS_INSTRUCTIONS = {
  [CONSUMER_DETAILS_NAMES.CONSUMER]: {
    name: 'Segmento',

    instruction: 'Indique el nombre exacto del segmento de mercado.',

    exampleOne: 'Estados Unidos\nEuropa\nAsia',

    exampleTwo: 'Agricultores\nEmpresas agrícolas',
  },

  [CONSUMER_DETAILS_NAMES.PERCENTAGE_SHARE]: {
    name: 'Participación porcentual',

    instruction: 'Indique el porcentaje correspondiente a cada segmento. La suma total debe ser igual al 100 %.',

    exampleOne: '',
    exampleTwo: '',
  },

  [CONSUMER_DETAILS_NAMES.PHYSICAL_SHARE]: {
    name: 'Participación en volumen',

    instruction: 'Indique la participación de cada segmento en unidades físicas utilizando datos claros y precisos.',

    exampleOne: '',
    exampleTwo: '',
  },
};

const MARKET_TRENDS_INSTRUCTIONS = {
  [MARKET_TRENDS_FIELD_NAMES.TREND_NAME]: {
    name: 'Nombre de la tendencia',

    instruction:
      'Identifique las principales tendencias del mercado relevantes para su sector y alineadas con la evolución actual de la industria.',

    exampleOne: 'Enfoque en la sostenibilidad',
    exampleTwo: 'Especialización en nichos de mercado',
  },

  [MARKET_TRENDS_FIELD_NAMES.TREND_CHARACTERISTICS]: {
    name: 'Análisis de la tendencia',

    instruction:
      'Describa las principales tendencias que están transformando el mercado. Explique los cambios en el comportamiento del consumidor, las nuevas preferencias, las prácticas del sector y los avances tecnológicos que influyen en la evolución de la industria.',

    exampleOne:
      'Los fabricantes desarrollan maquinaria más sostenible con menores emisiones y una creciente orientación hacia prácticas agrícolas respetuosas con el medio ambiente, como la agricultura regenerativa y ecológica.',

    exampleTwo:
      'La demanda de especialistas en sectores específicos, como el jurídico, sanitario, tecnológico y de marketing, continúa creciendo, impulsando una mayor especialización dentro de la industria de la traducción.',
  },
};

const CURRENT_MARKET_STRUCTURE_INSTRUCTIONS = {
  [CURRENT_MARKET_STRUCTURE_NAMES.TITLE]: {
    name: 'Título del gráfico',

    instruction: 'Introduzca un título claro y representativo del contenido del gráfico.',

    exampleOne: 'Estructura geográfica del mercado',
    exampleTwo: 'Estructura del mercado por segmento de clientes',
  },

  [CURRENT_MARKET_STRUCTURE_NAMES.CONSUMER]: {
    name: '',

    instruction: 'Indique el nombre exacto del segmento analizado.',

    exampleOne: `Estados Unidos
Europa
Asia`,

    exampleTwo: `Agricultores
Empresas agrícolas`,
  },

  [CURRENT_MARKET_STRUCTURE_NAMES.DATE]: {
    name: '',

    instruction: 'Indique la fecha de referencia de la información, incluyendo el mes y el año.',
  },

  [CURRENT_MARKET_STRUCTURE_NAMES.UNITS]: {
    name: '',
    instruction: '',
    exampleOne: '',
    exampleTwo: '',
  },

  [CURRENT_MARKET_STRUCTURE_NAMES.CONSUMER_DETAILS]: CONSUMER_DETAILS_INSTRUCTIONS,

  [CURRENT_MARKET_STRUCTURE_NAMES.SOURCE]: {
    name: 'Fuente de los datos',

    instruction: 'Indique la fuente fiable o la metodología utilizada para recopilar la información.',

    exampleOne: 'Eurostat',
    exampleTwo: 'Statista',
  },
};
const PRODUCT_ROW_INSTRUCTIONS = {
  name: 'Producto/Servicio',

  instruction:
    'Indique el nombre exacto del producto o servicio. Utilice la denominación oficial y asegúrese de que represente claramente la oferta.',

  exampleOne: 'Tractores de orugas',
  exampleTwo: 'Herramientas de traducción impulsadas por IA',
};

const AVERAGE_PRICES_TABLE_DATA_INSTRUCTIONS = {
  [REGIONS_PRODUCT_NAMES.PRODUCT]: PRODUCT_ROW_INSTRUCTIONS,
};

const MARKET_OVERVIEW_INSTRUCTIONS = {
  [MARKET_ANALYSIS_OVERVIEW_NAMES.MAIN_MARKET_OVERVIEW]: {
    name: 'Segmentación del mercado',

    instruction:
      'Defina el mercado objetivo. Describa sus principales características, los factores que determinan su funcionamiento, las barreras de entrada y los retos más relevantes. Presente una visión general de los segmentos del mercado considerando criterios geográficos, sectoriales, tipos de clientes u otras clasificaciones relevantes.',

    exampleOne:
      'El mercado analizado corresponde al sector de maquinaria agrícola. Se segmenta por tipo de maquinaria, incluyendo tractores, equipos de labranza, siembra y cosecha. El segmento de tractores representa la mayor cuota debido a su versatilidad y amplio uso en las actividades agrícolas.',

    exampleTwo:
      'El mercado de servicios lingüísticos opera a escala global y presta servicios tanto a empresas como a particulares. Aunque las barreras de entrada son relativamente bajas, la competencia es intensa. Los principales segmentos incluyen traducción escrita, interpretación, subtitulación y doblaje, siendo la traducción escrita el segmento predominante.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.SERVICES_PRODUCTS_SUMMARY]: {
    name: 'Resumen de productos y servicios',

    instruction:
      'Describa los principales productos o servicios disponibles en el mercado objetivo. Explique sus características diferenciales, su propósito, los enfoques de fijación de precios y cómo estos factores influyen en la demanda y la competencia.',

    exampleOne:
      'La oferta del mercado incluye tractores de Clase A y Clase B destinados a diferentes necesidades agrícolas. Los modelos de Clase A priorizan un menor impacto sobre el suelo, mientras que los de Clase B destacan por su resistencia y capacidad operativa. Los precios parten de 25.000 USD.',

    exampleTwo:
      'El mercado ofrece servicios de traducción humana, traducción automática y soluciones basadas en inteligencia artificial. Los precios varían según la complejidad del proyecto, mientras que la precisión, la rapidez y la eficiencia representan los principales factores competitivos.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.CONSUMERS_DESCRIPTION]: {
    name: 'Perfil de los clientes',

    instruction:
      'Resuma las características demográficas, el comportamiento y las preferencias de los clientes. Utilice datos para identificar segmentos, áreas geográficas y patrones de demanda.',

    exampleOne:
      'Los principales clientes son agricultores ubicados en regiones con suelos pesados o húmedos. Buscan tractores de alto rendimiento con baja presión sobre el terreno. La demanda aumenta durante las temporadas de siembra y cosecha.',

    exampleTwo:
      'Los clientes incluyen tanto particulares como empresas. La demanda se concentra principalmente en centros de negocios internacionales y regiones con una elevada diversidad lingüística. Las preferencias se orientan hacia soluciones rápidas, fiables y eficientes para la comunicación multilingüe.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.MARKET_COMPETITORS]: {
    name: 'Competidores del mercado',

    instruction:
      'Identifique los principales competidores del mercado. Destaque a los líderes del sector, su posicionamiento, fortalezas, debilidades y participación de mercado para ofrecer una visión clara del entorno competitivo.',

    exampleOne:
      'El mercado cuenta con aproximadamente 2.000 fabricantes de tractores. John Deere lidera el sector con una cuota cercana al 20 %, gracias a su reputación de innovación y fiabilidad. Los demás competidores se diferencian por su especialización, tamaño y propuesta de valor.',

    exampleTwo:
      'El mercado reúne unas 15 plataformas de servicios lingüísticos, encabezadas por T1 y STL. T1 mantiene el liderazgo gracias a su extensa red de traductores y una experiencia de usuario consolidada, mientras que STL se diferencia por la integración de tecnologías avanzadas y un servicio altamente personalizado.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.ACTUAL_AND_FORECASTED_CONSUMPTION]: {
    name: 'Análisis del consumo',

    instruction:
      'Analice las tendencias de consumo utilizando datos estadísticos. Presente tanto cifras históricas como proyecciones futuras, destacando las tasas de crecimiento y la evolución prevista del mercado.',

    exampleOne:
      'En 2022 se comercializaron un millón de tractores de orugas. Se prevé un crecimiento anual del 5 % al 7 %, impulsado por la mecanización agrícola y la creciente demanda de maquinaria eficiente y sostenible.',

    exampleTwo:
      'Según la consultora A, el mercado mundial de servicios lingüísticos alcanzó un valor estimado de 54.000 millones de USD en 2024. Se espera un crecimiento anual compuesto (CAGR) del 17 %, con un volumen cercano a 78.000 millones de USD en 2027.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.FORECASTED_CONSUMPTION_CHART]: FORECASTED_CONSUMPTION_CHART_INSTRUCTIONS,

  [MARKET_ANALYSIS_OVERVIEW_NAMES.MARKET_SHARE]: {
    name: 'Participación de mercado',

    instruction:
      'Analice la cuota de mercado actual de la empresa utilizando datos de ventas. Destaque el posicionamiento de la marca, el nivel de fidelización de los clientes, la capacidad de innovación y las estrategias de expansión.',

    exampleOne:
      'Actualmente la empresa posee una cuota de mercado del 0,02 %. Su tecnología innovadora en tractores de orugas y una estrategia de precios competitiva le han permitido fortalecer la fidelidad de sus clientes.',

    exampleTwo:
      'La empresa controla aproximadamente el 15 % del mercado de servicios lingüísticos. Su sólida reputación, una base de clientes fiel y la incorporación continua de innovación tecnológica refuerzan su posición competitiva.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.MARKET_TRENDS]: MARKET_TRENDS_INSTRUCTIONS,

  [MARKET_ANALYSIS_OVERVIEW_NAMES.SALES_METHOD]: {
    name: 'Estrategia comercial',

    instruction:
      'Describa los canales de venta utilizados para comercializar el producto o servicio. Incluya plataformas digitales, distribuidores, socios comerciales y estrategias de venta directa orientadas al cliente objetivo.',

    exampleOne:
      'Los principales canales de venta incluyen el sitio web corporativo, plataformas de comercio electrónico, distribuidores especializados en maquinaria agrícola y el equipo comercial propio.',

    exampleTwo:
      'La empresa aplica una estrategia omnicanal que combina su plataforma digital, alianzas con escuelas de idiomas y ventas consultivas dirigidas a clientes corporativos mediante demostraciones personalizadas.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.MARKET_STRUCTURE_DESCRIPTION]: {
    name: 'Resumen de la estructura del mercado',

    instruction: 'Analice el gráfico y describa los principales segmentos del mercado representados.',

    exampleOne:
      'Los segmentos principales incluyen fabricantes líderes como John Deere, Caterpillar y CNH Industrial, así como agricultores, cooperativas agrícolas y grandes explotaciones agroindustriales.',

    exampleTwo:
      'Los segmentos principales incluyen traductores independientes, agencias de traducción, proveedores de tecnología lingüística, departamentos internos de traducción y empresas especializadas en traducción automática.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.CURRENT_MARKET_STRUCTURE]: CURRENT_MARKET_STRUCTURE_INSTRUCTIONS,

  [MARKET_ANALYSIS_OVERVIEW_NAMES.MARKET_GROWTH_FACTORS]: {
    name: 'Factores de crecimiento',

    instruction:
      'Identifique los principales factores que impulsarán el crecimiento del mercado. Considere tendencias macroeconómicas, avances tecnológicos, cambios regulatorios y la evolución de las preferencias de los clientes. Explique cómo estos factores favorecerán el desarrollo del mercado.',

    exampleOne:
      'El crecimiento del mercado estará impulsado por la transición hacia una agricultura más sostenible, la adopción de tecnologías avanzadas y un entorno económico favorable. Estas tendencias incrementan la demanda de maquinaria agrícola eficiente, inteligente y respetuosa con el medio ambiente.',

    exampleTwo:
      'La expansión del mercado estará respaldada por el aumento del trabajo remoto, la colaboración internacional y la creciente digitalización de los negocios. Estos factores impulsan la demanda de plataformas de traducción e interpretación en línea.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.TECHNOLOGY_IMPACT]: {
    name: 'Impacto de la tecnología',

    instruction:
      'Evalúe cómo la evolución tecnológica influye en el sector. Destaque las oportunidades para innovar, mejorar la eficiencia operativa y transformar los modelos de negocio existentes.',

    exampleOne:
      'Los avances en automatización, agricultura de precisión, robótica y análisis de datos están redefiniendo la industria de la maquinaria agrícola. Estas tecnologías incrementan la productividad, optimizan el uso de recursos y reducen la dependencia de la mano de obra.',

    exampleTwo:
      'La inteligencia artificial y el aprendizaje automático están transformando la industria de los servicios lingüísticos al mejorar la precisión, la velocidad y la escalabilidad de las traducciones. Paralelamente, continúan surgiendo soluciones especializadas adaptadas a sectores y necesidades específicas.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.PRICE_STRATEGIES]: {
    name: 'Estrategias de precios',

    instruction:
      'Analice las estrategias de precios aplicadas por los competidores. Evalúe modelos de fijación de precios, descuentos, propuestas de valor y otros factores que influyen en su competitividad. Explique cómo su estrategia permitirá mantener el equilibrio entre crecimiento, rentabilidad y posicionamiento.',

    exampleOne:
      'Los competidores aplican estrategias como precios basados en el valor, precios de penetración y fijación basada en costes. También utilizan descuentos por volumen y promociones estacionales para aumentar las ventas y fortalecer su posición competitiva.',

    exampleTwo:
      'Los competidores emplean distintos modelos de precios, como tarifas por hora para traductores independientes, precios por palabra en agencias y suscripciones para plataformas tecnológicas. Analizar estas estrategias permite definir una política de precios competitiva y sostenible.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.AVERAGE_PRICES_TITLE]: {
    name: 'Resumen de precios',

    instruction: 'Introduzca un título claro y representativo para el gráfico.',

    exampleOne: 'Precios de tractores de orugas',
    exampleTwo: 'Precios de herramientas de traducción impulsadas por IA',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.AVERAGE_PRICES_DATE]: {
    name: '',

    instruction: 'Indique la fecha de referencia de la información, incluyendo el mes y el año.',
  },

  [MARKET_ANALYSIS_OVERVIEW_NAMES.AVERAGE_PRICES_CHART]: {
    [AVERAGE_PRICES_CHART_NAMES.AVERAGE_PRICES_REGIONS_ROWS]: AVERAGE_PRICES_TABLE_DATA_INSTRUCTIONS,
  },
};
const KEY_COMPETITORS_INSTRUCTIONS = {
  [KEY_COMPETITORS_NAMES.COMPETITOR]: {
    name: 'Nombre',

    instruction: 'Indique el nombre completo y oficial de la empresa.',

    exampleOne: 'AgroTech Innovations',
    exampleTwo: 'TransLink',
  },

  [KEY_COMPETITORS_NAMES.FILE]: {
    name: '',

    instruction: 'Suba el logotipo de la empresa en alta resolución, con dimensiones adecuadas y fondo transparente.',

    exampleOne: '',
    exampleTwo: '',
  },

  [KEY_COMPETITORS_NAMES.WEBSITE]: {
    name: 'Sitio web',

    instruction: 'Indique la dirección completa del sitio web oficial de la empresa.',

    exampleOne: 'agro.tech.innovations.com',
    exampleTwo: 'translink.com',
  },

  [KEY_COMPETITORS_NAMES.LOCATION]: {
    name: 'Ubicación',

    instruction: 'Indique la ciudad y el país donde la empresa está registrada oficialmente.',

    exampleOne: '134 E Main St, Marion, NC 28752, EE. UU.',
    exampleTwo: 'Portland, EE. UU.',
  },

  [KEY_COMPETITORS_NAMES.DESCRIPTION]: {
    name: 'Descripción del producto o servicio',

    instruction:
      'Describa las principales características del producto o servicio. Destaque los elementos innovadores, las ventajas tecnológicas, las funcionalidades clave y aquellos aspectos que diferencian la oferta en el mercado. Explique de qué manera estas características responden a las necesidades del cliente y fortalecen la propuesta de valor.',

    exampleOne:
      'La empresa ofrece una amplia gama de maquinaria agrícola, incluidos tractores, cosechadoras, sembradoras y pulverizadores. Su producto principal son tractores de alta potencia que utilizan biocombustibles como fuente principal de energía, diseñados para maximizar la productividad, la durabilidad y la eficiencia operativa.',

    exampleTwo:
      'El competidor ofrece una plataforma avanzada de servicios lingüísticos que incorpora herramientas de colaboración en tiempo real y acceso a una extensa red de traductores profesionales, proporcionando soluciones rápidas, precisas y escalables.',
  },

  [KEY_COMPETITORS_NAMES.POSITIONING]: {
    name: 'Posicionamiento',

    instruction:
      'Describa el posicionamiento competitivo de la empresa en el mercado. Destaque factores como el reconocimiento de marca, la reputación, el liderazgo y la influencia dentro del sector.',

    exampleOne:
      'La empresa se posiciona como un fabricante comprometido con la agricultura sostenible y el desarrollo de soluciones tecnológicas respetuosas con el medio ambiente.',

    exampleTwo:
      'La empresa ocupa una posición consolidada en el mercado gracias al reconocimiento de su marca y a una amplia red internacional de traductores. Su propuesta de valor se centra en ofrecer soluciones lingüísticas fiables, personalizadas y adaptadas a las necesidades específicas de cada cliente.',
  },

  [KEY_COMPETITORS_NAMES.SALES_CHANNELS]: {
    name: 'Canales de venta',

    instruction:
      'Describa los principales canales de comercialización utilizados por el competidor. Incluya distribuidores, alianzas comerciales, plataformas digitales, ventas directas u otros canales relevantes.',

    exampleOne:
      'La empresa comercializa sus productos a través de concesionarios autorizados, plataformas de comercio electrónico y equipos de ventas directas orientados a grandes explotaciones agrícolas.',

    exampleTwo:
      'La empresa vende sus servicios mediante su sitio web, plataformas digitales, asociaciones sectoriales y campañas de marketing dirigidas a clientes empresariales.',
  },

  [KEY_COMPETITORS_NAMES.PRICING_POLICY]: {
    name: 'Política de precios',

    instruction:
      'Resuma la política de precios del competidor. Explique las estrategias utilizadas —como precios basados en el valor, precios competitivos o estrategias dinámicas— y destaque cualquier elemento diferenciador.',

    exampleOne:
      'La empresa aplica una estrategia de precios competitivos, centrada en ofrecer una excelente relación calidad-precio y destacar los beneficios diferenciales de sus productos.',

    exampleTwo:
      'El competidor utiliza una estrategia de precios dinámicos que ajusta las tarifas según la demanda, la complejidad del proyecto y otros factores del mercado.',
  },

  [KEY_COMPETITORS_NAMES.ANNUAL_SALES_VOLUME]: {
    name: 'Volumen anual de ventas',

    instruction:
      'Indique el volumen anual de ventas correspondiente al último ejercicio fiscal. Puede expresarse en ingresos, unidades vendidas o ambos indicadores.',

    exampleOne: '5.000 unidades / 25 millones de USD',
    exampleTwo: '7 millones de USD',
  },

  [KEY_COMPETITORS_NAMES.MARKET_SHARE]: {
    name: 'Participación de mercado',

    instruction: 'Indique la cuota de mercado estimada de la empresa utilizando datos fiables.',

    exampleOne: '0,02 %',
    exampleTwo: '13 %',
  },

  [KEY_COMPETITORS_NAMES.CUSTOMER_LOYALTY_LEVEL]: {
    name: 'Nivel de fidelización de clientes',

    instruction:
      'Indique el nivel de fidelización de los clientes utilizando una clasificación sencilla: alto, medio o bajo.',

    exampleOne: 'Alto',
    exampleTwo: 'Medio',
  },
};
const COMPETITORS_STRENGTHS = {
  [COMPANY_QUALITIES_NAMES.STRENGTH]: {
    name: 'Fortaleza',

    instruction:
      'Identifique las principales fortalezas competitivas de la empresa. Destaque los recursos estratégicos, las capacidades diferenciadoras, la experiencia especializada y aquellos factores que le proporcionan una ventaja sostenible en el mercado.',

    exampleOne: ul([
      'Uso innovador de biocombustibles en la fabricación de tractores',
      'La planta de producción se encuentra junto a un importante nudo ferroviario',
      'Certificación de cumplimiento de estándares medioambientales',
    ]),

    exampleTwo: ul([
      'Amplia red internacional de traductores profesionales',
      'Sistema de pagos seguro',
      'Herramientas de colaboración en tiempo real',
    ]),
  },
};

const COMPETITORS_WEAKNESSES = {
  [COMPANY_QUALITIES_NAMES.WEAKNESSES]: {
    name: 'Debilidad',

    instruction:
      'Identifique las principales limitaciones internas de la empresa. Describa de forma objetiva las áreas susceptibles de mejora, incluyendo procesos, recursos, capacidades, eficiencia operativa o cualquier otro factor que pueda afectar a la competitividad.',

    exampleOne: ul([
      'Gama limitada de productos',
      'Costes de producción elevados debido al uso de tecnologías sostenibles',
    ]),

    exampleTwo: ul([
      'Interfaz de la plataforma desactualizada',
      'Precios superiores a los de la competencia',
      'Número limitado de herramientas para la búsqueda de traductores',
    ]),
  },
};

const COMPETITORS_QUALITIES_INSTRUCTIONS = {
  [COMPANY_QUALITIES_NAMES.NAME]: {
    name: 'Nombre',

    instruction: 'Indique el nombre completo y oficial de la empresa.',

    exampleOne: 'AgroTech Innovations',
    exampleTwo: 'TransLink',
  },

  [COMPANY_QUALITIES_NAMES.FILE]: {
    name: 'Logotipo',

    instruction: 'Suba el logotipo de la empresa en alta resolución, con dimensiones adecuadas y fondo transparente.',

    exampleOne: '',
    exampleTwo: '',
  },

  [COMPANY_QUALITIES_NAMES.STRENGTH]: COMPETITORS_STRENGTHS,

  [COMPANY_QUALITIES_NAMES.WEAKNESSES]: COMPETITORS_WEAKNESSES,
};
const COMPARISON_ITEM_INSTRUCTIONS = {
  [COMPETITORS_COMPARISON_NAMES.FEATURES_FOR_COMPARISON]: {
    [FEATURES_FOR_COMPARISON_NAMES.FEATURE]: {
      name: 'Criterio de comparación',

      instruction:
        'Indique las características o beneficios clave que diferencian su producto o servicio de las alternativas disponibles en el mercado. Destaque aquellos atributos que generan una ventaja competitiva clara.',

      exampleOne: 'Potencia del motor',
      exampleTwo: 'Tiempo medio de entrega',
    },
  },

  [FEATURES_LIST_NAMES.NAME]: {
    name: 'Nombre',

    instruction: 'Indique el nombre completo y oficial de la empresa.',

    exampleOne: 'John Deere',
    exampleTwo: 'LinguaWorld',
  },

  [FEATURES_LIST_NAMES.FILE]: {
    name: '',

    instruction: 'Suba el logotipo de la empresa en alta resolución, con dimensiones adecuadas y fondo transparente.',

    exampleOne: '',
    exampleTwo: '',
  },

  [FEATURES_LIST_NAMES.FEATURE]: {
    name: 'Valor',

    instruction:
      'Indique el valor correspondiente a este criterio utilizando métricas cuantificables siempre que sea posible. Destaque resultados medibles, ahorros de costes o mejoras de eficiencia.',

    exampleOne: '200 CV',
    exampleTwo: '20 horas',
  },

  [COMPETITORS_COMPARISON_NAMES.COMPETITOR_FEATURES_LIST]: {
    [FEATURES_LIST_NAMES.FILE]: {
      name: '',

      instruction: 'Suba el logotipo de la empresa en alta resolución, con dimensiones adecuadas y fondo transparente.',

      exampleOne: '',
      exampleTwo: '',
    },

    [FEATURES_LIST_NAMES.NAME]: {
      name: 'Nombre',

      instruction: 'Indique el nombre completo y oficial de la empresa.',

      exampleOne: 'John Deere',
      exampleTwo: 'LinguaWorld',
    },

    [FEATURES_LIST_NAMES.FEATURE]: {
      name: 'Valor',

      instruction:
        'Indique el valor correspondiente a este criterio utilizando métricas cuantificables siempre que sea posible. Destaque resultados medibles, ahorros de costes o mejoras de eficiencia.',

      exampleOne: '200 CV',
      exampleTwo: '20 horas',
    },
  },
};
const COMPETITIVE_ANALYSIS_INSTRUCTIONS = {
  [COMPETITIVE_ANALYSIS_NAMES.COMPETITORS]: {
    name: 'Análisis de la competencia',

    instruction:
      'Identifique a los competidores directos e indirectos y explique por qué representan una referencia relevante para su empresa. Compare su oferta, mercados objetivo, canales de distribución y posicionamiento para ofrecer una visión clara del entorno competitivo.',

    exampleOne:
      'Entre los competidores directos se encuentran AgroTech y Harvest Dynamics, ambos especializados en tractores de gran potencia. Entre los competidores indirectos figura GHY, que ofrece tractores de dos ruedas y otras soluciones alternativas. Todos ellos se dirigen al mismo segmento de clientes y utilizan canales de distribución similares.',

    exampleTwo:
      'Los principales competidores directos son TransLink y LinHub, plataformas de servicios lingüísticos que integran tecnologías de traducción automática y se orientan tanto a clientes particulares como corporativos. Entre los competidores indirectos destacan las plataformas de freelancers, que también ofrecen servicios de traducción.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.ATTRACTING_COMPETITORS_CUSTOMERS]: {
    name: 'Estrategia de captación de clientes',

    instruction:
      'Explique cómo atraerá clientes que actualmente trabajan con la competencia. Destaque su propuesta de valor, ventajas competitivas, estrategia de precios, actividades promocionales y otros factores que favorezcan la captación y fidelización.',

    exampleOne:
      'La empresa ofrecerá precios competitivos, descuentos de lanzamiento y programas de renovación de equipos. Además, reforzará su presencia mediante campañas de marketing digital, participación en ferias del sector y alianzas estratégicas.',

    exampleTwo:
      'La empresa desarrollará una estrategia integral de relaciones públicas y marketing en redes sociales, colaborando con líderes de opinión e influencers del sector. El fortalecimiento de la marca aumentará su visibilidad y facilitará la captación de nuevos clientes.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.COMPARISON_ITEM]: COMPARISON_ITEM_INSTRUCTIONS,

  [COMPETITIVE_ANALYSIS_NAMES.KEY_COMPETITORS]: KEY_COMPETITORS_INSTRUCTIONS,

  [COMPETITIVE_ANALYSIS_NAMES.COMPETITORS_QUALITIES]: COMPETITORS_QUALITIES_INSTRUCTIONS,

  [COMPETITIVE_ANALYSIS_NAMES.YOUR_COMPANY_QUALITIES]: COMPETITORS_QUALITIES_INSTRUCTIONS,

  [COMPETITIVE_ANALYSIS_NAMES.COMPETITORS_DIFFERENCE]: {
    name: 'Diferenciación del producto',

    instruction:
      'Compare su producto o servicio con el de los principales competidores. Destaque las diferencias en calidad, funcionalidades, rendimiento, innovación y otros atributos que aporten una ventaja competitiva sostenible.',

    exampleOne:
      'Los competidores ofrecen distintos tipos de tractores con características específicas, como modelos impulsados por biocombustibles o fabricados con materiales especializados. La empresa se diferencia por la fiabilidad de sus equipos, diseñados para ofrecer un rendimiento superior incluso en las condiciones agrícolas más exigentes.',

    exampleTwo:
      'Los competidores destacan por su reconocimiento de marca y una fuerte inversión en publicidad. La plataforma de la empresa se diferencia por integrar inteligencia artificial para mejorar la precisión, la velocidad y la eficiencia de las traducciones, ofreciendo un valor añadido claramente diferenciador.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.PURCHASING_PRODUCTS]: {
    name: 'Motivaciones de compra',

    instruction:
      'Analice los factores que influyen en la decisión de compra de los clientes cuando eligen a la competencia. Considere aspectos como el precio, la reputación de la marca, las funcionalidades, la calidad del servicio y otros elementos que condicionan su elección. Identifique oportunidades para fortalecer su propuesta de valor.',

    exampleOne:
      'Muchos clientes eligen a la competencia por su trayectoria consolidada, precios competitivos y una amplia gama de funcionalidades. Reforzar el posicionamiento de marca, optimizar la estrategia de precios y ofrecer ventajas diferenciadoras permitirá mejorar la competitividad.',

    exampleTwo:
      'Los clientes suelen optar por competidores con precios más bajos o marcas ampliamente reconocidas. Para incrementar su atractivo, la empresa deberá reforzar su propuesta de valor mediante una mejor experiencia de cliente, un soporte más sólido y una política de precios competitiva.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.FUTURE_EXPECTATIONS]: {
    name: 'Competencia futura',

    instruction:
      'Evalúe cómo podría evolucionar el entorno competitivo en los próximos años. Analice el atractivo del mercado, las barreras de entrada, las oportunidades aún no cubiertas y las posibles amenazas derivadas de nuevos competidores, guerras de precios o cambios en la cuota de mercado.',

    exampleOne:
      'La evolución tecnológica y los cambios en las preferencias de los clientes seguirán intensificando la competencia. La expansión de los mercados internacionales atraerá nuevos participantes, mientras que el sólido posicionamiento y el reconocimiento de marca de las empresas consolidadas continuarán representando una barrera importante para los nuevos competidores.',

    exampleTwo:
      'Aunque el mercado presenta barreras de entrada relativamente bajas debido a su naturaleza global, la competencia seguirá siendo intensa. Los nuevos participantes deberán diferenciarse mediante propuestas innovadoras y construir una marca sólida para ganar visibilidad y cuota de mercado.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.BARRIERS]: {
    name: 'Barreras de entrada',

    instruction:
      'Identifique las principales barreras que dificultan el acceso al mercado. Considere factores como la inversión inicial necesaria, los requisitos regulatorios, la fidelidad de los clientes hacia las marcas existentes, las economías de escala y otros elementos que limiten la entrada de nuevos competidores.',

    exampleOne:
      'El acceso al mercado requiere inversiones significativas en investigación, desarrollo y capacidad productiva. Además, la fuerte presencia de marcas consolidadas y su elevado reconocimiento dificultan la incorporación de nuevos participantes.',

    exampleTwo:
      'Los nuevos competidores deben afrontar importantes inversiones iniciales en infraestructura tecnológica y en la creación de una red fiable de traductores, lo que incrementa considerablemente el coste de entrada al mercado.',
  },

  [COMPETITIVE_ANALYSIS_NAMES.CHANGING_OF_CURRENT_MARKET]: {
    name: 'Factores de disrupción del mercado',

    instruction:
      'Analice las innovaciones y tendencias que podrían transformar el mercado en los próximos años. Evalúe el impacto potencial de las nuevas tecnologías, los cambios regulatorios y la evolución de las preferencias de los clientes sobre la dinámica competitiva del sector.',

    exampleOne:
      'La aparición de tractores totalmente autónomos impulsados por inteligencia artificial podría transformar profundamente la industria agrícola. Esta innovación reduciría la dependencia de la mano de obra y obligaría a los fabricantes tradicionales a adaptar rápidamente sus modelos de negocio.',

    exampleTwo:
      'La evolución de la traducción simultánea basada en inteligencia artificial representa uno de los principales factores de disrupción del sector. Estas soluciones ofrecen mayor velocidad y menores costes, obligando a los proveedores tradicionales a diferenciarse mediante servicios de mayor valor añadido y especialización.',
  },
};

const CONSUMER_NEEDS_INSTRUCTIONS = {
  [CONSUMER_NEEDS_NAMES.B2C]: {
    [B2C_NAMES.GENDER]: {
      name: 'Género',

      instruction: 'Indique el género predominante del público objetivo: masculino, femenino o neutro.',

      exampleOne: '',
      exampleTwo: '',
    },

    [B2C_NAMES.AGE]: {
      name: 'Edad',

      instruction:
        'Defina el rango de edad del público objetivo basándose en estudios de mercado y datos demográficos relevantes.',

      exampleOne: '25–65 años',
      exampleTwo: '18–45 años',
    },

    [B2C_NAMES.ANNUAL_INCOME]: {
      name: 'Ingresos',

      instruction:
        'Indique el rango de ingresos del público objetivo utilizando datos de mercado y capacidad adquisitiva.',

      exampleOne: 'A partir de 7.000 USD anuales',
      exampleTwo: 'Entre 2.000 y 10.000 USD mensuales',
    },

    [B2C_NAMES.PROFESSION]: {
      name: 'Profesión',

      instruction:
        'Identifique las principales profesiones de su público objetivo a partir del análisis demográfico y del mercado.',

      exampleOne: 'Agricultor',

      exampleTwo:
        'Estudiantes, empleados de empresas multinacionales, profesionales del ámbito académico y del sector turístico',
    },

    [B2C_NAMES.PERSONAL_INTERESTS]: {
      name: 'Intereses personales',

      instruction:
        'Describa los intereses, aficiones y estilo de vida del público objetivo que puedan influir en su comportamiento de compra.',

      exampleOne: 'Agricultura, maquinaria, innovación tecnológica, sostenibilidad y conservación del suelo.',

      exampleTwo: 'Idiomas, nuevas tecnologías, viajes y soluciones para una comunicación internacional eficiente.',
    },

    [B2C_NAMES.PURCHASING_HABITS]: {
      name: 'Hábitos de compra',

      instruction:
        'Analice el comportamiento de compra del público objetivo. Incluya la frecuencia de compra, los canales preferidos y los principales factores que influyen en la decisión de compra.',

      exampleOne:
        'Los clientes suelen adquirir uno o dos equipos cada siete años. Sus decisiones de compra se basan principalmente en la rentabilidad, la durabilidad y el rendimiento del producto.',

      exampleTwo:
        'Los clientes contratan los servicios principalmente a través de canales digitales y muestran preferencia por modelos de suscripción.',
    },

    [B2C_NAMES.NEEDS_AND_PROBLEMS]: {
      name: 'Necesidades y desafíos',

      instruction:
        'Identifique las principales necesidades, desafíos y problemas del público objetivo. Explique qué necesidades aún no están plenamente cubiertas y cómo su producto o servicio ofrece una solución eficaz.',

      exampleOne:
        'Los agricultores que trabajan en terrenos pesados o húmedos necesitan tractores fiables y resistentes capaces de operar en condiciones exigentes sin dañar el suelo.',

      exampleTwo:
        'Los clientes necesitan superar las barreras lingüísticas para comunicarse de forma rápida y eficaz. Buscan una solución digital fiable que facilite la comunicación en distintos idiomas.',
    },
  },

  [CONSUMER_NEEDS_NAMES.B2B]: {
    [B2B_NAMES.INDUSTRY]: {
      name: 'Sector',

      instruction:
        'Identifique el sector al que pertenece su cliente empresarial ideal. Seleccione el sector más adecuado o descríbalo si no aparece entre las opciones disponibles. Indique también la región donde desarrolla la mayor parte de su actividad. Si opera en varios mercados, mencione los más relevantes.',

      exampleOne: 'Agricultura',

      exampleTwo: 'Corporaciones multinacionales, tecnología, salud, sector jurídico y educación.',
    },

    [B2B_NAMES.ANNUAL_REVENUE]: {
      name: 'Facturación anual',

      instruction:
        'Indique el rango aproximado de facturación anual de su cliente empresarial ideal basándose en información financiera o estimaciones de mercado fiables.',

      exampleOne: 'Entre 60 y 120 millones de USD',

      exampleTwo: 'Entre 10 y 500 millones de USD',
    },

    [B2B_NAMES.NUMBER_OF_EMPLOYERS]: {
      name: 'Número de empleados',

      instruction:
        'Indique el tamaño habitual de la plantilla del cliente empresarial, incluyendo empleados a tiempo completo, parcial y personal contratado.',

      exampleOne: '300–900',

      exampleTwo: 'Más de 250',
    },

    [B2B_NAMES.REGION]: {
      name: 'Región',

      instruction:
        'Indique la principal región geográfica en la que opera el cliente empresarial. Si desarrolla su actividad en varios mercados, mencione los más importantes.',

      exampleOne: 'Estados Unidos',

      exampleTwo: 'Norteamérica, Europa y Asia-Pacífico',
    },

    [B2B_NAMES.PURCHASING_CYCLE]: {
      name: 'Ciclo de compra',

      instruction:
        'Describa el ciclo habitual de compra del cliente empresarial, indicando la frecuencia con la que toma decisiones de adquisición relevantes.',

      exampleOne: 'Cada 5–7 años',

      exampleTwo: 'Trimestral o anual',
    },
  },

  [CONSUMER_NEEDS_NAMES.PURCHASING_DECISION]: {
    name: 'Proceso de decisión de compra',

    instruction:
      'Si sus clientes son empresas u otras organizaciones, describa cómo se toman las decisiones de compra. Identifique quién tiene la autoridad para aprobar la adquisición y qué personas o departamentos influyen en el proceso.',

    exampleOne:
      'Las decisiones de compra suelen ser tomadas por los propietarios o la alta dirección. En determinados casos, los especialistas técnicos participan en la evaluación de las alternativas y aportan recomendaciones antes de la decisión final.',

    exampleTwo:
      'Las decisiones de compra suelen recaer en los responsables de departamento, directores de compras o gestores de proyectos. En el sector público, también pueden intervenir administradores y comités de contratación.',
  },

  [CONSUMER_NEEDS_NAMES.INFLUENCING_FACTORS]: {
    name: 'Factores de decisión',

    instruction:
      'Identifique los principales factores que influyen en la decisión de compra de sus clientes. Considere aspectos como las funcionalidades del producto, el precio, la reputación de la marca, la experiencia del cliente, las opiniones de otros usuarios y el valor diferencial de su oferta.',

    exampleOne:
      'La fiabilidad, la durabilidad, el rendimiento y el coste total de propiedad son factores determinantes. Los clientes valoran especialmente las soluciones capaces de responder eficazmente a las condiciones más exigentes de trabajo.',

    exampleTwo:
      'Los principales factores de decisión incluyen la calidad del servicio, la cobertura de idiomas, la facilidad de integración, la reputación del proveedor y la flexibilidad de la solución.',
  },

  [CONSUMER_NEEDS_NAMES.DIFFERENCES]: {
    name: 'Diferencias de comportamiento',

    instruction:
      'Describa las diferencias más relevantes en el comportamiento y las preferencias entre los distintos segmentos de clientes. Explique cómo varían sus hábitos de compra, expectativas y respuesta a las estrategias comerciales.',

    exampleOne:
      'Las grandes empresas agrícolas priorizan compras de mayor volumen y eficiencia operativa, mientras que las explotaciones familiares valoran principalmente la fiabilidad y la rentabilidad de cada equipo. Estas diferencias influyen directamente en la planificación comercial y de producción.',

    exampleTwo:
      'Las empresas buscan rapidez y eficiencia, mientras que las instituciones públicas priorizan la precisión, la seguridad y el cumplimiento normativo. Cada segmento responde de manera diferente a los mensajes y canales de marketing.',
  },

  [CONSUMER_NEEDS_NAMES.HOW_CUSTOMERS_SATISFIED]: {
    name: 'Nivel de satisfacción del mercado',

    instruction:
      'Evalúe el nivel de satisfacción de los clientes con las soluciones actualmente disponibles en el mercado. Destaque los aspectos mejor valorados y las áreas donde aún existen oportunidades de mejora.',

    exampleOne:
      'El nivel de satisfacción es, en general, positivo, aunque muchos clientes siguen demandando mejoras en durabilidad, rendimiento y relación calidad-precio. Esto crea oportunidades para ofrecer propuestas con mayor valor añadido.',

    exampleTwo:
      'La satisfacción con los servicios actuales es moderada. Los usuarios señalan procesos de registro complejos y limitaciones en la accesibilidad de algunas plataformas, lo que abre oportunidades para mejorar la experiencia del cliente.',
  },

  [CONSUMER_NEEDS_NAMES.DEMAND]: {
    name: 'Generación de demanda',

    instruction:
      'Analice si su empresa opera en un mercado con una demanda ya consolidada o si está creando una nueva categoría mediante una propuesta innovadora. Explique cómo esta situación influye en su estrategia comercial y de crecimiento.',

    exampleOne:
      'La empresa participa en un mercado con una demanda consolidada. La mecanización agrícola continúa impulsando la necesidad de maquinaria especializada, aunque la innovación tecnológica permite diferenciar la oferta existente.',

    exampleTwo:
      'La empresa está creando una nueva demanda mediante una plataforma digital innovadora para la búsqueda de traductores. Esta propuesta introduce una solución diferenciada en un segmento aún poco desarrollado.',
  },

  [CONSUMER_NEEDS_NAMES.CUSTOMER_BASE_SIZE]: {
    name: 'Base de clientes',

    instruction:
      'Describa el tamaño actual de su base de clientes. Incluya indicadores que demuestren el interés del mercado, como número de clientes, registros, consultas, pedidos anticipados o tasas de crecimiento.',

    exampleOne:
      'La empresa cuenta con más de 800 explotaciones agrícolas como clientes. En 2022, la base de clientes creció un 12 %, y el 40 % corresponde a clientes recurrentes, lo que refleja un elevado nivel de fidelización.',

    exampleTwo:
      'La plataforma reúne actualmente más de 20.000 traductores registrados en todo el mundo y suma alrededor de 100 nuevos registros al mes. Durante 2022 gestionó aproximadamente 50.000 pedidos, un 23 % más que el año anterior.',
  },

  [CONSUMER_NEEDS_NAMES.SURVEY]: {
    name: 'Validación del mercado',

    instruction:
      'Describa la investigación realizada con clientes para validar el producto o servicio. Explique el objetivo del estudio, el perfil de los participantes, la metodología utilizada, las principales preguntas formuladas y los hallazgos más relevantes obtenidos.',

    exampleOne:
      'La empresa realiza encuestas de satisfacción dirigidas a clientes recientes mediante entrevistas telefónicas. Los resultados muestran que el 80 % de los participantes se declara satisfecho y manifiesta intención de volver a comprar.',

    exampleTwo:
      'La empresa utiliza cuestionarios en línea para recopilar opiniones sobre la experiencia del usuario e identificar oportunidades de mejora. Los resultados reflejan una demanda creciente de nuevos métodos de pago y de una aplicación móvil, proporcionando información valiosa para el desarrollo futuro del producto.',
  },
};

export const MARKET_ANALYSIS_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.MARKET_OVERVIEW]: MARKET_OVERVIEW_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.COMPETITIVE_ANALYSIS]: COMPETITIVE_ANALYSIS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.CONSUMER_NEEDS]: CONSUMER_NEEDS_INSTRUCTIONS,
};
